import { render, staticRenderFns } from "./Observacion.vue?vue&type=template&id=aa22b0b0"
import script from "./Observacion.vue?vue&type=script&lang=js"
export * from "./Observacion.vue?vue&type=script&lang=js"
import style0 from "./Observacion.vue?vue&type=style&index=0&id=aa22b0b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports